import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useContent } from '../../context/ContentContext';
import { resolveCoreBeliefs, saveCoreBeliefField } from '../../data/coreBeliefs';
import RichTextField from './RichTextField';

export default function EditableBeliefField({ index, field, tag = 'span', className = '', multiline = false }) {
  const { isEditing } = useAuth();
  const { getContent, setContentValue } = useContent();
  const beliefs = resolveCoreBeliefs(getContent);
  const value = beliefs[index]?.[field] || '';

  const saveValue = (nextValue) => {
    saveCoreBeliefField(setContentValue, beliefs, index, field, nextValue);
  };

  return (
    <RichTextField
      isEditing={isEditing}
      tag={tag}
      className={className}
      value={value}
      onChange={saveValue}
      multiline={multiline}
    />
  );
}
